// @ts-nocheck
import styled from 'styled-components';

export const ReportDownloadFormStyled = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
    background-color: ${props => props.theme.grayUltraUltraUltraLight};
    padding: 1rem;
    @media (min-width: 900px) {
      padding: 2rem 13.25rem;
    }

    .reportDownloadForm {
      &__title {
        font-family: ${props => props.theme.fontRegular};
        font-size: ${props => props.theme.fontSizeL};
        line-height: ${props => props.theme.fontSizeXL};
        letter-spacing: 0;
        color: ${props => props.theme.uiColors.textTitle};
      }

      &__section {
        display: flex;
        flex-direction: column;
        gap: 24px;
        padding-top: 40px;
      }

      &__settingsSection {
        padding: 16px;
        border-radius: 4px;
        background-color: ${props => props.theme.white};
      }
    }
`;
